/* eslint-disable default-case */
import React, { Component } from 'react'
import { Box } from 'grommet';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import ModifyTelephoneStep1 from '../Components/ModifyTelephoneStep1';
import ModifyTelephoneStep2 from '../Components/ModifyTelephoneStep2';
import InsertOTPPassword from '../Components/InserisciOTPPassword';
import { VerifyOtpOldCellNumCtrl } from '../Controllers/otpCtrl/VerifyOtpOldCellNumCtrl';
import { VerifyOtpNewTelCtrl } from '../Controllers/otpCtrl/VerifyOtpNewTelCtrl';
import RiepilogoOTP from '../Components/RiepilogoOTP';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
/*import { logout } from '../Utils/Utility';*/



class ModifyTelephoneNumber extends Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            telephone: sessionStorage.getItem('cellNumber'),
            newTelephone: '',
            buttonState: false,
            msgError: '',
            step: 1,
            otp: '',
            dataOldOTP: '',
            dataNewOTP: '',
            dataNewTel: '',
            dataOldTel: '',
            dataOTP: '',
            status: '',
            errorOtp: false,
            showTimeoutModal: false,
            loading: false
        }
        //this.setTelephone = this.setTelephone.bind(this);
        this.setOtp = this.setOtp.bind(this);
    }

    verifyOldTelOtp = () => {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        self.setState({loading: true});
        VerifyOtpOldCellNumCtrl(function (data, status) {
            self.setState({
                dataOldOTP: data,
                status: status,
                otp: '',
                loading: false
            }, self.nextStep())
        }, function (status, error) {
            self.setState({
                status: status,
                loading: false
            }, function () {
                if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                    self.nextStep();
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    //     pathname: '/login'
                    // })
                } else if (status === 406 && error === '5704') {
                    this.setState({
                        msgOtp: 'Codice OTP scaduto',
                        errorOtp: true
                    })
                } else if (status === 406 && error === '5707') {
                    this.setState({
                        msgOtp: 'Codice OTP non valido',
                        errorOtp: true
                    })
                } else if (status === 406 && error === '5708') {
                    this.setState({
                        msgOtp: 'Ultimo tentativo prima del blocco utenza',
                        errorOtp: true
                    })
                } else if (status === 406 && error === '5709') {
                    this.setState({
                        msgOtp: 'Utenza bloccata',
                        errorOtp: false
                    })
                } else {
                    self.setState({
                        msgOtp: 'Si è verificato un errore, riprovare!',
                        errorOtp: true
                    })
                }
            })
        }, this.state.otp, token, ids)
    }

    verifyOtpNewTel = () => {

        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        var self = this;
        self.setState({loading: true});

        VerifyOtpNewTelCtrl(function (data) {

            self.setState({
                dataNewTel: data,
                status: 200,
                loading: false
            }, self.nextStep())
        }, function (status, error) {
            self.setState({
                status: status,
                loading: false
            }, function () {
                if (self.state.status === 500 || self.state.status === 400 || self.state.status === 404 || self.state.status === 403) {
                    self.nextStep();
                } else if (self.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    //     pathname: '/login'
                    // })
                } else if (status === 406 && error === '5704') {
                    self.setState({
                        msgOtp: 'Codice OTP scaduto',
                        errorOtp: true
                    })
                }  else if (status === 406 && error === '5707') {
                    self.setState({
                        msgOtp: 'Codice OTP non valido',
                        errorOtp: true
                    })
                } else if (status === 406 && error === '5708') {
                    self.setState({
                        msgOtp: 'Ultimo tentativo prima del blocco utenza',
                        errorOtp: true
                    })
                } else if (status === 406 && error === '5709') {
                    self.setState({
                        msgOtp: 'Utenza bloccata',
                        errorOtp: true
                    })
                } else {
                    self.setState({
                        msgOtp: 'Si è verificato un errore, riprovare!',
                        errorOtp: true
                    })
                }
            })
        }, this.state.newTelephone, this.state.otp, token, ids)
    }

    setOtp = (e) => {
        var otpVal = e.target.value;
        if (/^\d{6,6}$/.test(otpVal)) {
            this.setState({
                otp: otpVal,
                buttonStateOtp: false,
                msgOtp: ''
            })
        }
        else if (otpVal.length === 0) {
            this.setState({
                otp: otpVal,
                buttonStateOtp: true,
                msgOtp: ''
            })
        } else {
            this.setState({
                otp: otpVal,
                buttonStateOtp: true,
                msgOtp: 'Inserire 6 cifre'
            })
        }
    }

    nextStep = () => {
        const { step } = this.state
        this.setState({
            step: step + 1,
        })
    }

    prevStep = () => {
        const { step } = this.state
        this.setState({
            step: step - 1,
        })
    }
    firstStep = () => {
        /*const { step } = this.state*/
        this.setState({
            step: 1,
        })
    }
    goHome = () => {
        this.props.history.push('/Home');
    }

    disableButtonTel = (tel) => {
        var regexTel = RegExp(/^\+(?:[0-9] ?){2,}[0-9]$/);
        var telOK = regexTel.test(tel);
        if (telOK) {
            if (tel.length > 3 && tel.length < 16) {
                this.setState({
                    msgError: '',
                    buttonState: false,
                    newTelephone: tel
                })
            }
        }
        else {
            if (tel === '' || tel === undefined || tel === null) {
                this.setState({
                    msgError: '',
                    buttonState: true
                })
            }
            else {
                this.setState({
                    msgError: 'Inserire un numero internazionale corretto (+112345, +3912345)',
                    buttonState: true
                })

            }
        }
    }


    form(step) {
        const { newTelephone, telephone, buttonState, msgError, dataOldOTP, dataNewOTP, dataOldTel, dataNewTel, dataOTP, otp, buttonStateOtp, msgOtp, errorOtp,status, loading, showTimeoutModal } = this.state;
        const values = { newTelephone, telephone, buttonState, msgError, dataOldOTP, dataNewOTP, dataOldTel, dataNewTel, dataOTP, otp, buttonStateOtp, msgOtp, errorOtp, status, loading, showTimeoutModal };

        switch (step) {
            case 1:
                return <ModifyTelephoneStep1
                    nextStep={this.nextStep}
                    hideNumber={this.hideNumber}
                    values={values}
                />

            case 2:
                return <InsertOTPPassword
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    values={values}
                    step={this.state.step}
                    otpFunction={this.verifyOldTelOtp}
                    setOtp={this.setOtp}

                />

            case 3:
                return <ModifyTelephoneStep2
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    values={values}
                    goHome={this.goHome}
                    disableButton={this.disableButtonTel}
                />
            case 4:
                return <InsertOTPPassword
                    prevStep={this.prevStep}
                    values={values}
                    step={this.state.step}
                    setOtp={this.setOtp}
                    nextStep={this.nextStep}
                    otpFunction={this.verifyOtpNewTel}
                />
            case 5:
                return <RiepilogoOTP
                    firstStep={this.firstStep}
                    values={values}
                />

        }
    }
    render() {
        const { step } = this.state;


        return (

            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                    <Box className='contentbox'>
                        {this.form(step)}
                    </Box>
                </Box>
            </Box>
        )
    }
}

export default ModifyTelephoneNumber = withRouter(ModifyTelephoneNumber)